import { render, staticRenderFns } from "./PostCarousel.vue?vue&type=template&id=093efe78&"
import script from "./PostCarousel.vue?vue&type=script&lang=js&"
export * from "./PostCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports